export const SAVE_SEARCH_RES = "SAVE_SEARCH_RES";
export const GET_SEARCH_RES = "GET_SEARCH_RES";
export const CURRENT_GENERALINDICATOR = "CURRENT_GENERALINDICATOR";
export const PORT_SEARCH = "PORT_SEARCH";
export const LOGIN = "LOGIN";
